import React from 'react';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavOpen: false
    };
  }


  render() {
    return (
      <section class="banner-section-6 text-center text-white d-flex">
        <div class="container my-auto">
          <div class="row">
            <div class="col-md-8 text-center text-md-left d-flex d-sm-flex d-md-flex justify-content-center align-items-center justify-content-md-start align-items-md-center justify-content-xl-center mb-4">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true}>
                <h1 class="text-uppercase font-weight-bold">Energía renovable para un futuro sostenible</h1>
                <p class="my-3">Descripción.</p>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;


